export default {
  title: 'Bramka płatnicza',
  description:
    'Twoje własne bramki płatnicze dla zamówień online. Cała kwota zamówienia trafia na konto Twojej bramki; rozliczenia z restauracjami odbywają się po Twojej stronie.',
  toasts: {
    load_error: 'Nie udało się załadować konfiguracji bramki',
  },
  not_enabled: {
    title: 'Spreedly nie jest jeszcze włączone dla Twojego konta',
    description:
      'Lokalne bramki płatnicze są aktywowane przez FoodAmigos. Skontaktuj się z przedstawicielem FoodAmigos, aby rozpocząć.',
  },
  processor_mode: {
    title: 'Kto przetwarza płatności?',
    description:
      'To ustawienie obowiązuje dla wszystkich Twoich restauracji. Możesz je później zmienić w ustawieniach partnera, jeśli żadna restauracja nie jest aktywna.',
    save: 'Zapisz',
    options: {
      platform: {
        title: 'FoodAmigos przetwarza płatności',
        badge: 'Polecane',
        description:
          'Zajmujemy się kontem płatności, weryfikacją i wypłatami. Każda restauracja dodaje dane firmy i przechodzi krótką weryfikację w Adyen.',
        methods: 'Akceptowane: {{methods}}',
      },
      provider: {
        title: 'Korzystam z własnego dostawcy',
        description:
          'Połącz dostawcę płatności, którego już używasz. Wypłaty, opłaty i weryfikacja pozostają po jego stronie.',
      },
    },
    payment_methods: {
      card: 'Karta',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
      pay_by_bank: 'Płatność bankowa',
      giropay: 'giropay',
      sepa_debit: 'SEPA',
    },
    locked: {
      platform: 'FoodAmigos przetwarza płatności dla wszystkich Twoich restauracji.',
      provider: 'Twoje restauracje przyjmują płatności przez własnych dostawców.',
    },
    confirm_choice: {
      title: 'Ustawić płatności na „{{mode}}”?',
      description:
        'Dotyczy to wszystkich prowadzonych przez Ciebie restauracji. Możesz to później zmienić w ustawieniach partnera, ale tylko gdy żadna restauracja nie jest aktywna.',
      confirm: 'Zapisz i kontynuuj',
    },
    switch: {
      link: 'Zmień sposób przetwarzania płatności',
      confirm: {
        confirm: 'Przełącz',
        provider: {
          title: 'Przełączyć na własnego dostawcę?',
          description: 'Restauracje korzystające z płatności FoodAmigos wrócą do statusu Nie skonfigurowano.',
        },
        platform: {
          title: 'Przełączyć na płatności FoodAmigos?',
          description: 'Restauracje korzystające z własnych dostawców wrócą do statusu Nie skonfigurowano.',
        },
      },
      unavailable: {
        title: 'Płatności FoodAmigos nie są jeszcze dostępne',
        description: 'Płatności FoodAmigos nie są jeszcze dostępne w Twoim kraju.',
        confirm: 'OK',
      },
      blocked: {
        title: 'Skontaktuj się z FoodAmigos, aby to zmienić',
        description_one:
          '{{count}} restauracja przyjmuje aktywne płatności. Zmiana oznacza ponowne wdrożenie u nowego dostawcy. Nasz zespół zaplanuje to z Tobą.',
        description_few:
          '{{count}} restauracje przyjmują płatności na żywo. Zmiana oznaczałaby ponowną rejestrację u nowego dostawcy. Nasz zespół zaplanuje to razem z Tobą.',
        description_many:
          '{{count}} restauracji przyjmuje płatności na żywo. Zmiana oznaczałaby ponowną rejestrację u nowego dostawcy. Nasz zespół zaplanuje to razem z Tobą.',
        description_other:
          '{{count}} restauracji przyjmuje aktywne płatności. Zmiana oznaczałaby ponowne wdrożenie u nowego dostawcy. Nasz zespół zaplanuje to z Tobą.',
        confirm: 'Napisz do FoodAmigos',
        subject_one: 'Zmień sposób przetwarzania płatności ({{count}} aktywna restauracja)',
        subject_few: 'Zmień sposób przetwarzania płatności ({{count}} aktywne restauracje)',
        subject_many: 'Zmień sposób przetwarzania płatności ({{count}} aktywnych restauracji)',
        subject_other: 'Zmiana sposobu przetwarzania płatności ({{count}} aktywnych restauracji)',
      },
    },
    toasts: {
      load_error: 'Nie udało się wczytać konfiguracji płatności',
      save_error: 'Nie udało się zapisać konfiguracji płatności',
      chosen: 'Konfiguracja płatności zapisana',
      switched: 'Sposób przetwarzania płatności zmieniony',
    },
  },
  gateways: {
    title: 'Połączeni dostawcy',
    empty: 'Podłącz dostawcę płatności, którego już używasz. Twoje restauracje zostaną wdrożone pod jego kontem.',
    connect_another: 'Połącz dostawcę',
    support_hint:
      'Gdy restauracja przyjmuje już realne płatności, zmiana dostawcy jest planowana wspólnie z nami — napisz na {{email}}.',
    kinds: {
      stripe_connect: 'Stripe Connect',
      spreedly: 'Bramka płatnicza',
      platform_adyen: 'Płatności FoodAmigos',
    },
    statuses: {
      connected: 'Połączono',
      disconnected: 'Rozłączono',
      needs_attention: 'Wymaga uwagi',
    },
    issue: {
      connect_not_enabled: {
        title: 'Stripe Connect nie jest włączony na koncie powiązanym z {{name}}',
        description:
          'Stripe nie może tworzyć kont dla Twoich restauracji, dopóki Connect nie zostanie włączony. Włącz go w Panelu Stripe, a następnie sprawdź ponownie tutaj.',
      },
      account_restricted: {
        title: 'Stripe wstrzymuje nowe konta w ramach {{name}}',
        description:
          'Stripe tymczasowo ograniczył możliwość tworzenia kont połączonych na Twoim koncie. Zaloguj się do Panelu Stripe, potwierdź, że chcesz utworzyć te konta, a następnie sprawdź ponownie tutaj.',
      },
      loss_liability_unaccepted: {
        title: 'Stripe wymaga, aby {{name}} najpierw zaakceptował odpowiedzialność za straty',
        description:
          'Twoja platforma Stripe nie zaakceptowała jeszcze odpowiedzialności za ujemne salda na kontach Twoich restauracji, więc Stripe ich nie utworzy. W panelu Stripe otwórz Ustawienia → Connect → Profil platformy i zatwierdź oświadczenie o odpowiedzialności za straty, a następnie sprawdź ponownie tutaj. Poniższą uwagę Stripe dotyczącą Accounts v2 możesz zignorować.',
      },
      account_creation_refused: {
        title: 'Stripe odmówił utworzenia konta restauracji w ramach {{name}}',
        description: 'Zapoznaj się z poniższą wiadomością w Panelu Stripe, a następnie sprawdź ponownie tutaj.',
      },
      key_invalid: {
        title: 'Stripe nie akceptuje już klucza połączonego dla {{name}}',
        description:
          'Klucz został zmieniony, unieważniony lub wygasł. Utwórz nowy klucz w panelu Stripe, a następnie zastąp go tutaj.',
      },
      key_access_limited: {
        title: 'Stripe ograniczył klucz połączony dla {{name}}',
        description:
          'Ograniczony klucz nie może tworzyć transferów ani wypłat dla Twoich restauracji. W Stripe Dashboard otwórz Developers → API keys i przywróć kluczowi pełny dostęp, a następnie sprawdź ponownie tutaj — lub odnów klucz i zastąp go tutaj.',
      },
      provider_said: 'Odpowiedź Stripe: „{{message}}”',
      hint: 'Dopóki problem nie zostanie rozwiązany, restauracje powiązane z tym dostawcą nie mogą rozpocząć przyjmowania płatności online.',
      open_stripe: 'Otwórz Panel Stripe',
      check_again: 'Sprawdź ponownie',
      replace_key: 'Zastąp klucz',
      cleared: 'Stripe ponownie akceptuje Twoje restauracje',
      still_blocked: 'Stripe nadal odmawia — zobacz powyżej, co odpowiedział',
    },
    refused: {
      provider_said: 'Co powiedział {{name}}: „{{message}}”',
      reference: 'Numer referencyjny:',
      contact_support: 'Napisz do pomocy technicznej',
      support_subject: 'Odrzucono połączenie z dostawcą płatności: {{name}} (ref {{reference}})',
      account_in_test_mode: {
        action: 'Wyłącz tryb testowy w Authorize.Net, w {{path}}, a następnie spróbuj ponownie.',
        open: 'Otwórz Authorize.Net',
      },
      processor_not_configured: {
        action:
          'Skontaktuj się z dostawcą usług płatniczych – firmą, która otworzyła Twoje konto Authorize.Net – i poproś o dokończenie konfiguracji z procesorem płatności. Nowe klucze tego nie zmienią. Następnie spróbuj ponownie.',
        action_card_connect:
          'Poproś pomoc techniczną CardConnect o włączenie autoryzacji bez fizycznej karty (e-commerce) dla tego identyfikatora sprzedawcy. Nowe dane uwierzytelniające API tego nie zmienią. Następnie spróbuj ponownie.',
      },
    },
    table: {
      primary_tag: 'Domyślny',
      live_count_one: '{{count}} przyjmuje płatności',
      live_count_few: '{{count}} przyjmuje płatności',
      live_count_many: '{{count}} przyjmuje płatności',
      live_count_other: '{{count}} przyjmuje płatności',
      attention_count_one: '{{count}} wymaga uwagi',
      attention_count_few: '{{count}} wymaga uwagi',
      attention_count_many: '{{count}} wymaga uwagi',
      attention_count_other: '{{count}} wymaga uwagi',
      columns: {
        connection: 'Dostawca',
        status: 'Status',
        restaurants: 'Restauracje',
        methods: 'Metody lokalne',
      },
      methods_count: '{{enabled}} z {{capable}} włączonych',
    },
    picker: {
      recommended: 'Polecane',
      connect: 'Połącz',
      stripe_connect: {
        title: 'Stripe Connect',
        description:
          'Użyj własnego konta Stripe. Każda restauracja przechodzi własny proces onboardingu Stripe; wypłaty i opłaty pozostają w Stripe.',
        already_connected: 'Już połączono. Użyj opcji Edytuj dane logowania na liście, aby zmienić klucz.',
        already_connected_short: 'Już połączono.',
      },
      stripe_direct: {
        title: 'Stripe (bezpośrednio)',
        description: 'Obciążaj każdą restaurację przez jedno Twoje konto Stripe.',
        unavailable: 'Niedostępne jeszcze w Twoim regionie.',
      },
      paypal: {
        direct: 'Oferuj PayPal z własnego konta biznesowego PayPal.',
        braintree: 'Przyjmuj karty, PayPal i Venmo za pośrednictwem konta Braintree.',
      },
      other: {
        title: 'Inni dostawcy',
        search: 'Szukaj dostawców',
        loading: 'Ładowanie dostawców…',
        no_match: 'Brak dostawcy o nazwie „{{query}}”.',
        none_available: 'W Twoim regionie nie ma jeszcze innych dostępnych dostawców.',
        load_error: 'Nie udało się załadować listy dostawców.',
        retry: 'Spróbuj ponownie',
        pinned_match: 'Ten dostawca jest przypięty powyżej.',
      },
      not_listed: {
        action: 'Nie ma mojego dostawcy na liście',
        subject: 'Wniosek o dostawcę płatności: {{query}}',
      },
      use_foodamigos: {
        no_account: 'Nie mam konta u żadnego z nich',
        switch: 'Przełącz na płatności FoodAmigos',
      },
    },
    orchestrated: {
      title: 'Połącz {{name}}',
      replace_title: 'Zmień dane logowania dla {{name}}',
      intro: 'Wprowadź dane logowania z konta {{name}}. Sprawdzamy je w {{name}} przed zapisaniem.',
      auth_mode: 'Sposób logowania do tego dostawcy',
      checking: 'Sprawdzanie w {{name}}…',
      paypal_direct: {
        intro:
          'Wklej Client ID i Secret aplikacji REST PayPal, przez którą Twoje restauracje mają przyjmować płatności PayPal. Sprawdzamy je w PayPal, zanim cokolwiek zostanie zapisane.',
        client_id: 'Client ID',
        secret: 'Secret',
        hint: 'PayPal Developer Dashboard → Apps & Credentials, zakładka Live. Użyj aplikacji REST swojego konta biznesowego.',
        hint_sandbox:
          'Panel dewelopera PayPal → Apps & Credentials, zakładka Sandbox: to środowisko akceptuje tylko aplikacje sandbox.',
      },
      braintree: {
        intro:
          'Wprowadź klucze API swojego konta Braintree. PayPal i Venmo zaczynają działać po połączeniu ich w Braintree Control Panel — włączasz je później dla każdego połączenia osobno.',
      },
      authorize_net: {
        intro:
          'Wprowadź identyfikator logowania API i klucz transakcji swojego konta Authorize.Net. Sprawdzamy je za pomocą małej testowej autoryzacji: w dzienniku transakcji Authorize.Net widnieje jako odrzucone 1,00 USD, a środki nie są przesyłane. Konto musi być w Trybie na żywo, ponieważ w Trybie testowym Authorize.Net odrzuca każdą prawdziwą płatność.',
        hint: 'Oba znajdziesz w panelu Merchant Interface Authorize.Net, w {{path}}.',
      },
      card_connect: {
        intro:
          'Wprowadź identyfikator sprzedawcy, nazwę użytkownika i hasło swojego aktywnego konta CardConnect (CardPointe). Sprawdzamy je autoryzacją na kwotę 1,00, którą od razu anulujemy: w dzienniku transakcji CardPointe zobaczysz ją jako odrzuconą lub anulowaną transakcję na 1,00, a żadne środki nie zostaną przesunięte.',
      },
      stripe_direct: {
        intro:
          'Wklej klucz tajny lub ograniczony konta Stripe, przez które mają płacić wszystkie restauracje. Webhook potrzebny Stripe skonfigurujemy za Ciebie.',
        secret_key: 'Klucz tajny lub ograniczony Stripe',
        hint: 'Stripe → Developers → API keys. Zaczyna się od sk_ (tajny) lub rk_ (ograniczony). Klucz ograniczony wymaga uprawnień do zapisu dla: Charges and Refunds, Customers, PaymentIntents, PaymentMethods, SetupIntents, Tokens i Webhook Endpoints. Klucz publiczny nie jest potrzebny.',
        prefix_error: 'Klucze tajne Stripe zaczynają się od sk_, a klucze ograniczone od rk_.',
      },
      connected: {
        title: '{{name}} jest połączony.',
        description:
          'Użyjemy tych danych logowania dla wszystkich Twoich restauracji. Każda restauracja nadal dodaje swoje dane firmowe.',
      },
      errors: {
        generic: 'Nie udało się połączyć z {{name}}',
      },
    },
    stripe: {
      title: 'Połącz Stripe Connect',
      rotate_title: 'Zastąp klucz Stripe Connect',
      rotate_intro:
        'Wklej nowy klucz tajny i klucz publikowalny z tego samego konta Stripe. Twoje restauracje pozostaną połączone.',
      intro: 'Wklej klucz tajny i klucz publikowalny swojego konta Stripe. Oba znajdują się w Developers → API keys.',
      verify_and_connect: 'Zweryfikuj i połącz',
      checking: 'Sprawdzanie w Stripe…',
      secret_key: {
        label: 'Klucz tajny',
        hint: 'Stripe → Developers → API keys. Zaczyna się od sk_.',
        prefix_error: 'Klucze tajne zaczynają się od sk_. To wygląda na inny rodzaj klucza.',
      },
      restricted_key: {
        label: 'Ograniczony klucz API',
        hint: 'Stripe → Developers → API keys → Create restricted key. Zaczyna się od rk_. Skonfiguruj go zgodnie z opisem powyżej.',
        prefix_error: 'Ograniczone klucze zaczynają się od rk_. To wygląda na inny rodzaj klucza.',
      },
      use_restricted_key: 'Użyj zamiast tego klucza ograniczonego',
      use_secret_key: 'Użyj zamiast tego klucza tajnego',
      publishable_key: {
        label: 'Klucz publikowalny',
        hint: 'Na tej samej stronie Stripe. Zaczyna się od pk_. Twoje sklepy potrzebują go do akceptowania kart.',
        prefix_error: 'Klucze publikowalne zaczynają się od pk_.',
        mode_mismatch:
          'Jeden klucz jest kluczem produkcyjnym (live), a drugi testowym. Oba muszą pochodzić z tego samego trybu Stripe.',
      },
      name: {
        label: 'Nazwij to połączenie',
        hint: 'Opcjonalnie. Wyświetlane wszędzie tam, gdzie widnieje ten dostawca.',
        placeholder: 'Stripe Connect',
      },
      permissions: {
        title: 'Jak utworzyć ten klucz',
        start_blank:
          'Gdy Stripe zapyta, jak będziesz używać klucza, wybierz „{{option}}”. Wszystkie uprawnienia są na początku ustawione na {{none}}.',
        intro:
          'Następnie ustaw przełącznik w każdym z tych wierszy sekcji. Ustawia on wszystkie uprawnienia w danej sekcji, więc nie trzeba przechodzić ich pojedynczo.',
        rows_checked: 'Sprawdzamy: {{rows}}',
        secret_key_hint: 'Wszystkie pozostałe sekcje zostaw na {{none}}. Klucz tajny nie potrzebuje żadnej z nich.',
        open_stripe: 'Otwórz swoje klucze API Stripe',
      },
      login_setting: {
        title: 'Wyłącz logowanie Stripe dla swoich restauracji',
        description:
          'W panelu Stripe otwórz Ustawienia → Connect → Wypłaty → Konta zewnętrzne i wyłącz „{{setting}}”. Gdy ta opcja jest włączona, Stripe wymaga od każdej restauracji utworzenia loginu Stripe z numerem telefonu podczas rejestracji, a przy każdej kolejnej wizycie prosi o kod SMS, więc osoba bez dostępu do tego telefonu nie może kontynuować.',
        bank_details: 'Nic nie tracisz: restauracje wpisują dane bankowe w naszym własnym formularzu.',
        open_stripe: 'Otwórz to ustawienie Stripe',
      },
      errors: {
        generic: 'Nie udało się połączyć ze Stripe',
      },
    },
    default_choice: {
      label: 'Użyj jako domyślnego dla restauracji',
      hint: 'Nowe restauracje oraz restauracje bez dostawcy są łączone z nim automatycznie. Pozostaw niezaznaczone, aby samodzielnie wybierać dostawcę dla każdej restauracji.',
    },
    manage: {
      payment_methods: 'Metody płatności',
      edit_credentials: 'Edytuj dane logowania',
      edit_credentials_unavailable: 'Edytuj dane logowania (ten dostawca nie jest obecnie oferowany)',
      set_primary: 'Ustaw jako domyślny dla nowych restauracji',
      clear_primary: 'Przestań używać jako domyślnego dla nowych restauracji',
      rename: {
        action: 'Zmień nazwę połączenia',
        title: 'Zmień nazwę tego połączenia',
        confirm: 'Zapisz',
      },
      disconnect: {
        action: 'Rozłącz',
        title: 'Rozłączyć {{name}}?',
        confirm: 'Rozłącz',
        warning_one: '{{count}} restauracja jest z nim powiązana i wróci do statusu Nieskonfigurowana.',
        warning_few: '{{count}} restauracje są z nim powiązane i wrócą do stanu Nie skonfigurowano.',
        warning_many: '{{count}} restauracji jest z nim powiązanych i wróci do stanu Nie skonfigurowano.',
        warning_other: '{{count}} restauracji jest z nim powiązanych i wrócą do statusu Nieskonfigurowana.',
        live: {
          title_one: 'Płatności online zostaną wstrzymane dla {{count}} działającej restauracji',
          title_few: 'Płatności online zostaną wstrzymane dla {{count}} działających restauracji',
          title_many: 'Płatności online zostaną wstrzymane dla {{count}} działających restauracji',
          title_other: 'Płatności online zostaną wstrzymane dla {{count}} działającej restauracji',
          description:
            'Po odłączeniu klienci tych restauracji nie będą mogli płacić online. Każda z nich wróci do stanu „Nie skonfigurowano”, dopóki nie połączysz jej z innym dostawcą.',
          refunds: 'Zamówień opłaconych już przez tego dostawcę nie będzie można zwrócić z poziomu FoodAmigos.',
          pause_one: 'Wstrzymaj płatności online dla tej restauracji',
          pause_few: 'Wstrzymaj płatności online dla tych {{count}} restauracji',
          pause_many: 'Wstrzymaj płatności online dla tych {{count}} restauracji',
          pause_other: 'Wstrzymaj płatności online dla tych {{count}} restauracji',
          confirm: 'Odłącz i wstrzymaj płatności',
        },
      },
      remove: {
        action: 'Usuń z listy',
        title: 'Usunąć {{name}}?',
        description: 'Jest już odłączony i żadna restauracja go nie używa. Nie będzie już widoczny na tej liście.',
        confirm: 'Usuń',
      },
    },
    payment_methods: {
      title: 'Metody płatności dla {{name}}',
      description:
        'Wybierz metody lokalne, które Twoje restauracje oferują u tego dostawcy. Każda z nich jest widoczna tylko wtedy, gdy waluta restauracji się zgadza.',
      save: 'Zapisz',
      publishable_key: {
        label: 'Klucz publikowalny Stripe',
        hint: 'Stripe potrzebuje go do wyświetlenia formularza płatności. Znajdziesz go w panelu Stripe w Developers → API keys.',
        invalid: 'Klucz publiczny zaczyna się tutaj od {{prefix}}.',
        clear_to_save:
          'Należy do drugiego trybu Stripe. Wyczyść to pole, aby zapisać przy wyłączonych wszystkich metodach lokalnych.',
      },
      on_other_connection: 'już włączone dla {{connection}}',
      other_currency: 'niedostępne w {{currency}}',
      delivery_only: '{{name}} (tylko zamówienia z dostawą — wymagany adres klienta)',
      invite_only:
        '{{name}} (Stripe udostępnia to tylko na zaproszenie — najpierw poproś o dostęp w panelu Stripe, w przeciwnym razie Stripe odrzuci każdą płatność)',
      also_enable: {
        stripe: 'Włącz te same metody w panelu Stripe w Settings → Payment methods, inaczej Stripe je odrzuci.',
        provider: 'Twoja umowa z tym dostawcą musi obejmować metody, które tu włączasz.',
        braintree:
          'Najpierw połącz PayPal i Venmo w Braintree Control Panel w sekcji Settings → Processing, w przeciwnym razie Braintree je odrzuci. Venmo jest przeznaczone dla restauracji w USA rozliczających się w dolarach.',
        paypal_direct:
          'Płatności PayPal są przekazywane na to konto biznesowe PayPal. W przypadku Venmo połącz Braintree.',
      },
    },
    actions: {
      cancel: 'Anuluj',
    },
    toasts: {
      load_error: 'Nie udało się wczytać połączonych dostawców',
      credentials_replaced: 'Dane logowania zmienione',
      save_error: 'Nie udało się zapisać',
      connected: 'Stripe Connect połączono',
      renamed: 'Zmieniono nazwę połączenia',
      primary_set: 'Zaktualizowano domyślnego dostawcę',
      primary_cleared:
        'Domyślny dostawca usunięty. Nowe restauracje nie są powiązane z żadnym dostawcą, dopóki go nie wybierzesz.',
      disconnected: 'Dostawca rozłączony',
      removed: 'Dostawca został usunięty',
      payment_methods_saved: 'Zapisano metody płatności',
    },
  },
  restaurants: {
    title: 'Restauracje',
    description: 'Status przyjmowania płatności online w każdej restauracji.',
    search: 'Szukaj restauracji',
    filters: {
      all: 'Wszystkie ({{count}})',
      needs_attention: 'Wymaga uwagi ({{count}})',
    },
    empty: 'Brak restauracji.',
    empty_attention: 'Nic nie wymaga Twojej uwagi.',
    columns: {
      restaurant: 'Restauracja',
      provider: 'Dostawca',
      status: 'Status',
      action: 'Akcja',
    },
    no_provider: '—',
    foodamigos_payments: 'Płatności FoodAmigos',
    groups: {
      not_set_up: 'Nieskonfigurowane',
      business_details_missing: 'Brak danych firmy',
      hosted_not_finished: 'Formularz {{provider}} nieukończony',
      hosted_not_finished_generic: 'Formularz dostawcy nieukończony',
      waiting_for_provider: 'Oczekiwanie na dostawcę',
      action_needed: 'Wymagana akcja',
      payments_live: 'Płatności aktywne',
      online_payments_off: 'Płatności online wyłączone',
      waiting_for_partner: 'Oczekiwanie na Ciebie',
    },
    link_expired: 'Link wygasł',
    actions: {
      set_up: 'Skonfiguruj',
      change: 'Zmień',
      unlink: 'Odłącz',
      remind: 'Przypomnij właścicielowi',
      reminded: 'Przypomniano · ponownie {{time}}',
      start_over: 'Rozpocznij konfigurację Stripe od nowa',
    },
    assign: {
      title: 'Którego dostawcę powinien użyć {{name}}?',
      label: 'Dostawca',
      confirm: 'Zapisz',
      cancel: 'Anuluj',
      primary: 'Domyślny',
      none: 'Najpierw połącz dostawcę.',
    },
    unlink: {
      title: 'Odłączyć {{name}} od {{provider}}?',
      title_generic: 'Odłączyć {{name}} od dostawcy?',
      description:
        'Restauracja wraca do statusu Nie skonfigurowano, więc możesz wybrać dla niej właściwego dostawcę. Dostawca pozostaje połączony z Twoimi pozostałymi restauracjami.',
      confirm: 'Odłącz',
    },
    pause: {
      title: 'Płatności online są wstrzymane dla {{name}}',
      description:
        'Jej klienci nie będą mogli płacić online, dopóki restauracja nie zostanie ponownie skonfigurowana i zweryfikowana u dostawcy.',
      refunds: 'Zamówień opłaconych już przez obecnego dostawcę nie można już zwrócić z poziomu FoodAmigos.',
      confirm: 'Wstrzymaj płatności online dla tej restauracji',
    },
    start_over: {
      title: 'Rozpocząć od nowa konfigurację Stripe dla {{name}}?',
      points: {
        not_used: 'Jego obecne konto Stripe ({{account}}) nie będzie już używane dla tej restauracji.',
        kept: 'Konto nie zostanie usunięte: pozostaje w Twoim Stripe, gdzie możesz je odrzucić.',
        fresh: 'Następne „Kontynuuj” rozpocznie od pierwszej strony Stripe, a można użyć innego adresu e-mail.',
        paused:
          'Jeśli restauracja przyjmuje płatności online, zostaną wstrzymane do czasu zakończenia nowej konfiguracji.',
      },
      confirm: 'Zacznij od nowa',
      blocked: {
        received_payments:
          'Konto Stripe tej restauracji otrzymało płatności, więc jego konfiguracji nie można rozpocząć od nowa. Skontaktuj się z pomocą techniczną, aby je zmienić.',
        partner_action_needed: 'Najpierw napraw problem widoczny w Twoim Stripe Connect.',
      },
    },
    toasts: {
      load_error: 'Nie udało się załadować Twoich restauracji',
      assigned: 'Dostawca zapisany',
      assign_error: 'Nie udało się zapisać dostawcy',
      unlinked: 'Restauracja odłączona',
      unlink_error: 'Nie udało się odłączyć restauracji',
      reminded: 'Przypomnienie wysłane do właściciela',
      remind_error: 'Nie udało się wysłać przypomnienia',
      cooling_down: 'Właściciel został już dziś przypomniany',
      started_over: 'Konfiguracja Stripe rozpoczęta od nowa',
      start_over_error: 'Nie udało się rozpocząć konfiguracji Stripe od nowa',
    },
  },
  footer: {
    text: 'Twoja opłata za usługę FoodAmigos jest naliczana niezależnie od tego, z którego dostawcy korzysta restauracja.',
    link: 'Zobacz Rozliczenia',
  },
};
